import { Component, Input, OnChanges, ViewChild } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-notes",
	templateUrl: "./manage-notes.component.html",
	styleUrls: ["./manage-notes.component.scss"]
})
export class ManageNotesComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	@ViewChild("addExpander") addExpander: any;

	public adminLogs: any[];
	public newLog: any = {};

	constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		await this.RefreshLogs();
	}

	public async RefreshLogs() {
		this.adminLogs = undefined;
		const logs = await this.api.GetAdminLogs(this.asset.asset_id);
		for (const log of logs) {
			log.editTitle = log.title;
			log.editContent = log.content;
		}
		this.adminLogs = logs;
	}

	public async SaveLog(log: any) {
		if (log.admin_log_id) {
			// Existing, update
			await this.api.UpdateAdminLog(log.admin_log_id, log.editTitle, log.editContent);
		} else {
			await this.api.CreateAdminLog(this.asset.asset_id, log.editTitle, log.editContent);
		}
		this.newLog = {};
		this.addExpander.Close();
		await this.RefreshLogs();
	}

	public async DeleteLog(admin_log_id: number) {
		await this.api.DeleteAdminLog(admin_log_id);
		await this.RefreshLogs();
	}
}
